import { translate } from "@kaltura/mediaspace-shared-utils";
import { GenAI24Icon } from "@kaltura/ds-react-icons";
import { ConfigSidebarButtonDescriptor } from "@kaltura/mediaspace-shared-data-kms-config/ConfigSidebarButton";
import { SidebarMenuButtonWithAnalytics, SidebarMenuButtonWithAnalyticsProps } from "@kaltura/mediaspace-shared-layout";
import { GenieSidePanel, GenieSidePanelProps } from "./GenieSidePanel";

/*
 * Genie sidebar button descriptor for the DS sidebar rail (visible only on C&C pages).
 * On non-C&C pages this button is registered with showInRail:false — the panel still
 * exists in the sidebar system but is opened exclusively via GenieHeaderButton.
 */
export const GenieSidebarButton: ConfigSidebarButtonDescriptor<
    SidebarMenuButtonWithAnalyticsProps,
    GenieSidePanelProps
> = {
    id: "genie",
    buttonComponent: SidebarMenuButtonWithAnalytics,
    buttonProps: { title: translate("Ask anything"), icon: <GenAI24Icon />, analyticsText: "Genie" },
    contentsComponent: GenieSidePanel,
};
